import React, { useEffect, useState } from "react";
import httpClient from "../../../httpClient";
import { Box, Button, Grid, Paper, TextField } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../../redux/slice/user";
import { Route, Routes } from "react-router-dom";
import axios from "axios";

import VIEMenuPage from "./VIEMenuPage";
import CsqaTable from "./task/csqa/CsqaTable";
import HlswTable from "./task/hlsw/HlswTable";
import MmluTable from "./task/mmlu/MmluTable";
import TfqaTable from "./task/tfqa/TfqaTable";
import ComgTable from "./task/comg/ComgTable";
import HhhTable from "./task/hhh/HhhTable";
import WngdTable from "./task/wngd/WngdTable";
import DropTable from "./task/drop/DropTable";
import BolqTable from "./task/bolq/BolqTable";
import MmmuTable from "./task/mmmu/MmmuTable";
import VieAsgPage from "./task/vie-asg/VieAsgPage";
import MemberTable from "../hrm/member/MemberTable";
import GncWorkLogTable from "./log/GncWorkLogTable";
import VieWorkLogTable from "./log/VieWorkLogTable";
import SwTable from "./gnc/sw/SwTable";
import KmTable from "./gnc/km/KmTable";
import SwWorkerStatus from "./gnc/sw/SwWorkerStatus";
import SwINSTWorkerStatus from "./gnc/sw/SwINSTWorkerStatus";
import KmWorkerStatus from "./gnc/km/KmWorkerStatus";
import KmTRSWorkerStatus from "./gnc/km/KmTRSWorkerStatus";



// 페이지당 유저 권한을 체크하여 메뉴와 페이지를 제어
const VIEPage = (props:any) => {
  const dispatch = useDispatch();
  // const userinfo = useSelector((state:any) => state.userInfo.data)
  const nav = useNavigate();

  const [pageRole, setPageRole] = useState("");

  const auth = useSelector((state:any)=> state.userInfo.data)
  const roles = auth.user.roles;
  const email = auth.user.email;

  // const admin_role = auth.user.roles.find((role:any) => ['ADMIN'].includes(role.role));


  const checkPageRole = (datas:any) => {
    // console.log('유저 권한 리스트' , datas)
    let adminRole = roles.find((role:any) => role.role === "ADMIN")
    let managerRole = roles.find((role:any) => role.role === "MANAGER")


    if((adminRole && managerRole) || adminRole) {
      setPageRole("ADMIN");
    } else if(managerRole) {
      setPageRole("MANAGER");
    }
  }
  
  // console.log('pageRole',pageRole)

  // const getAuth = async () => {
  //   api.get('/@me',{params:{email:email}})
  //   .then((resp:any) => {dispatch(setUserInfo(resp.data)) , console.log('관리자 페이지', resp.data) })
  //     // alert("파일 업로드가 완료되었습니다.");
  //   .catch((error:any) => {console.error('에러',error.response);})
  //   // alert("파일 업로드 실패. " + error.response.data.error);
  // }

  useEffect(() => {
    checkPageRole(roles)
  },[roles])

  const open = props.switchPage;
  var control = 'block';
  if(open)
    control = 'none'

  return (
    <Box sx={{display: control, justifyContent: "center", padding:"30px 40px 30px 40px"}}>
        {/* <Paper sx={{ margin: "0px", padding: "16px", borderTop: "4px solid #3e36a5"}}> */}
          <Box sx={{padding:"20px 8px 8px 8px"}}>
            <Box display="flex">
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "20px", letterSpacing:"-2px"}}>2024</Box>
              <Box sx={{marginLeft:"auto", marginRight:"20px", fontWeight:600, fontSize: "16px"}}>{"HOME > VIE"}</Box>
            </Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <Box display="flex" justifyContent="left">
              <Box>
                <VIEMenuPage pageRole={pageRole} />
              </Box>
              <Box sx={{width:"100%"}}>
                <Routes>
                  <React.Fragment>
                    {/* {(pageRole == "MANAGER") || (pageRole == "ADMIN") || (pageRole == "WORKER_DIALOG") ? 
                    <Route path="dialogSample/*" element={<DialogSampleTable />} />
                    :""}
                    {(pageRole == "MANAGER") || (pageRole == "ADMIN") || (pageRole == "WORKER_SOUND") ? 
                    <Route path="soundSample/*" element={<SoundSampleTable />} />
                    :""}
                    {(pageRole == "MANAGER") || (pageRole == "ADMIN") || (pageRole == "WORKER_NOISE") ? 
                    <Route path="noiseSample/*" element={<NoiseSampleTable />} />
                    :""} */}

                    {(pageRole == "MANAGER") || (pageRole == "ADMIN") ? 
                    <React.Fragment>
                      <Route path="task/csqa/*" element={<CsqaTable />} />
                      <Route path="task/hlsw/*" element={<HlswTable />} />
                      <Route path="task/mmlu/*" element={<MmluTable />} />
                      <Route path="task/tfqa/*" element={<TfqaTable />} />
                      <Route path="task/comg/*" element={<ComgTable />} />
                      <Route path="task/hhh/*" element={<HhhTable />} />
                      <Route path="task/wngd/*" element={<WngdTable />} />
                      <Route path="task/drop/*" element={<DropTable />} />
                      <Route path="task/bolq/*" element={<BolqTable />} />
                      <Route path="task/mmmu/*" element={<MmmuTable />} />
                      <Route path="task/vie-asg/*" element={<VieAsgPage />} />

                      <Route path="sw/*" element={<SwTable />} />
                      <Route path="sw-worker-status/*" element={<SwWorkerStatus />} />
                      <Route path="sw-inst-worker-status/*" element={<SwINSTWorkerStatus />} />
                      <Route path="km/*" element={<KmTable />} />
                      <Route path="km-worker-status/*" element={<KmWorkerStatus />} />
                      <Route path="km-trs-worker-status/*" element={<KmTRSWorkerStatus />} />
                      {/* <Route path="task/tfqa/*" element={<TfqaTable />} />
                      <Route path="task/comg/*" element={<ComgTable />} />
                      <Route path="task/hhh/*" element={<HhhTable />} />
                      <Route path="task/wngd/*" element={<WngdTable />} />
                      <Route path="task/bolq/*" element={<BolqTable />} /> */}
                    </React.Fragment>
                    :""}

                    {/* {(pageRole == "MANAGER") || (pageRole == "ADMIN") || (pageRole == "WORKER_SOUND") ? 
                    <Route path="soundSample/*" element={<SoundUploadTable />} />
                    :""}
                    {(pageRole == "MANAGER") || (pageRole == "ADMIN") || (pageRole == "WORKER_NOISE") ? 
                    <Route path="noiseSample/*" element={<NoiseUploadTable />} />
                    :""} */}
                    
                    {pageRole == "ADMIN" ? 
                    <React.Fragment>
                      <Route path="memberList/*" element={<MemberTable />} />  
                      <Route path="vieWorkLog/*" element={<VieWorkLogTable />} />
                      <Route path="gncWorkLog/*" element={<GncWorkLogTable />} />  
                    </React.Fragment>
                    : ""}
                  </React.Fragment>
                </Routes>
                {/* <Paper>메뉴 상세 페이지</Paper> */}
              </Box>
            </Box>
          </Box>
        {/* </Paper> */}
    </Box>
  );
};

export default VIEPage;
